import classNames from 'classnames';
import { MouseEventHandler, ReactNode } from 'react';
import { AccordionContextValue } from '~/components/Accordion/v2/Accordion.hooks';
import { AccordionBody } from '~/components/Accordion/v2/Body/AccordionBody';
import {
  AccordionButton,
  AccordionButtonProps,
} from '~/components/Accordion/v2/Button/AccordionButton';
import { AccordionRoot, AccordionRootProps } from '~/components/Accordion/v2/Root/AccordionRoot';
import styles from './Accordion.module.scss';

export type AccordionProps = {
  title?: ReactNode | ((value: AccordionContextValue) => ReactNode);
  children?: ReactNode | ((value: AccordionContextValue) => ReactNode);
  onButtonClick?: MouseEventHandler;
} & AccordionRootProps &
  Pick<AccordionButtonProps, 'icon'>;
export const Accordion = ({
  active,
  title,
  className,
  icon,
  children,
  onButtonClick,
  ...props
}: AccordionProps) => (
  <AccordionRoot className={classNames(styles.root, className)} active={active} {...props}>
    <AccordionButton icon={icon} onClick={onButtonClick}>
      {title}
    </AccordionButton>
    <AccordionBody>{children}</AccordionBody>
  </AccordionRoot>
);

Accordion.Root = AccordionRoot;
Accordion.Button = AccordionButton;
Accordion.Body = AccordionBody;
